import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { goToPage, setOptionalNetworks } from '../../WifiManagementBlockSlice';
import BtnSubmit from '../../../../Shared/Buttons/BtnSubmit';
import infoIcon from './images/info-icon.svg';

const NetworkTypePage = (props) => {
    const [errorMessage, setErrorMessage] = useState('');

    useEffect(() => {

    }, []);

    return (
        <div className='network-type-page'>

            <div className='title'> רשת אורחים </div>
            <div className='sub-title'> אילו תדרים תרצו להגדיר? </div>

            <div className='network-list-wrapper'>

                {
                    props.optionalNetworks &&
                    props.optionalNetworks.map((item, index) => {
                        return (
                            <a key={index} className={`network-item ${item.isChecked ? 'active' : ''}`} href='#' onClick={(e)=> onNetworkClick(e, item.name, item.isChecked)}>
                                <span> {getNetworkType(item.name)} </span>
                            </a>                         
                        );
                    })
                }

                { errorMessage && <div className='error-message'>{errorMessage}</div> }  

            </div>

            <div className='bottom-remark-wrapper'>                    
                <div className='icon-wrapper' style={{backgroundImage:infoIcon.bg()}}></div>            
                <div className='text-wrapper'> מומלץ לפתוח רשתות לפני סוג המכשירים שברצונכם לחבר. אם הרשת מיועדת לבית חכם, מומלץ לפתוח רשת בתדר 2.4 GHz </div>
            </div>

            <div className='button-wrapper'>
                <BtnSubmit text='המשך' onclick={handleGuestNetworkClick} formid='guest-network-page' />
            </div>                      

        </div>
    );

    function getNetworkType(frequency) {
        switch (frequency) {
            case '2.4GHZ': return '2.4 GHz Network';
            case '5GHZ': return '5 GHz Network';
            case '6GHZ': return 'wifi6 Network';
            default: return '';
        }
    }

    function onNetworkClick(e, name, isChecked) {
        e.preventDefault();         
        props.setOptionalNetworks({ name: name, isChecked: !isChecked }); 

        if (!isChecked) {
            setErrorMessage('');
        }
    }

    function handleGuestNetworkClick() {
        const selectedNetworks = props.optionalNetworks.filter(x=> x.isChecked);
        if (selectedNetworks?.length > 0) {
            props.goToPage('addNetworkPage');
        }
        else {
            setErrorMessage('נא לבחור רשת אחת לפחות');
        }        
    }

};

const mapStateToProps = (state) => {
    return {
        optionalNetworks: state.wifiManagementBlock?.optionalNetworks
    };
};

const mapDispatchToProps = {
    goToPage,
    setOptionalNetworks
};

export default connect(mapStateToProps, mapDispatchToProps)(NetworkTypePage);